<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div>
        <!-- search and actions start -->
        <div class="px-sm-4 d-flex flex-column flex-sm-row align-items-center justify-content-between">
            <CoInput
                v-model="tableFilter"
                type="search"
                icon="search"
                :placeholder="$t('placeholders.search')"
                :aria-label="$t('labels.search')"
                no-border
                background="white"
                class="align-self-sm-start mb-2 mb-sm-0 mr-sm-3"
            />

            <div class="d-block d-sm-flex">
                <CoButton variant="primary" class="m-1 my-sm-0 mr-sm-0" @click="createCategory">
                    {{ $t('labels.create') }}
                </CoButton>
            </div>
        </div>
        <!-- search and actions end -->

        <div class="px-sm-4">
            <div class="mt-4">
                <CoTable
                    :loading="loading"
                    :items="filteredCategories"
                    :columns="columns"
                    :itemsPerPage="20"
                    striped
                    clickable-rows
                    @clickedRow="editCategory"
                >
                    <template v-slot:Name="{ item }">
                        {{ item.Name }}
                    </template>
                    <template v-slot:Actions="{ item }">
                        <!-- Keep destructive actions separate from row navigation. -->
                        <div @click.stop>
                            <CoConfirmation
                                :message="$t('messages.deletewarning')"
                                :confirmLabel="$t('labels.delete')"
                                :cancelLabel="$t('labels.cancel')"
                                confirm-variant="danger"
                                @confirm="deleteCategory(item)"
                            >
                                <CoRoundButton
                                    icon="trash"
                                    variant="icon"
                                    :disabled="deleting"
                                    :aria-label="`${$t('labels.delete')} ${item.Name}`"
                                />
                            </CoConfirmation>
                        </div>
                    </template>
                </CoTable>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import CoButton from '../../../components/Atoms/co-button/CoButton.vue';
import CoRoundButton from '../../../components/Atoms/co-round-button/CoRoundButton.vue';
import CoConfirmation from '../../../components/Molecules/co-confirmation/CoConfirmation.vue';
import CoInput from '../../../components/Molecules/co-input/CoInput.vue';
import CoTable from '../../../components/Molecules/co-table/CoTable.vue';
import EventBus from '../../../eventBus';

export default {
    name: 'ResourceCategories',
    components: { CoButton, CoConfirmation, CoInput, CoRoundButton, CoTable },
    data() {
        return {
            objects: [],
            loading: false,
            deleting: false,
            tableFilter: '',
        };
    },
    computed: {
        columns() {
            return [
                {
                    key: 'Name',
                    title: this.$t('labels.name'),
                },
                {
                    key: 'Actions',
                    title: this.$t('labels.actions'),
                    notSortable: true,
                    style: 'width: 5rem; text-align: right;',
                },
            ];
        },
        filteredCategories() {
            if (!this.tableFilter) {
                return this.objects;
            }

            const searchTerm = this.tableFilter.toLowerCase();

            // Keep filtering local so the shared table only renders the already normalized category list.
            return this.objects.filter((category) => category.Name && category.Name.toLowerCase().includes(searchTerm));
        },
    },
    created() {
        this.getCategories();
    },
    methods: {
        createCategory() {
            this.$router.push('/admin/booking/categories/create');
        },
        editCategory(index, category) {
            if (!category) {
                return;
            }

            this.$router.push(`/admin/booking/categories/edit/${category.ID}`);
        },
        getCategories() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/booking/category/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    if (response.data && response.data.Categories) {
                        this.objects = response.data.Categories;
                    }
                })
                .catch(() => {
                    this.loading = false;
                    EventBus.$emit('ERROR', {
                        Message: this.$t('errors.failedGeneric'),
                        Details: '',
                    });
                });
        },
        deleteCategory(category) {
            if (!category || this.deleting) {
                return;
            }

            this.deleting = true;
            const data = JSON.stringify(category);
            axios({
                method: 'DELETE',
                url: '/admin/booking/category',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(() => {
                    this.deleting = false;
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.bookingCategoryDeleted'),
                        Details: '',
                    });
                    const index = this.objects.findIndex((item) => item.ID === category.ID);
                    if (index !== -1) {
                        this.objects.splice(index, 1);
                    }
                })
                .catch(() => {
                    this.deleting = false;
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.bookingCategoryDeleteFailed'),
                        Details: '',
                    });
                });
        },
    },
};
</script>
